class FixSafariKeyframesResize {
	constructor() {
		if (/apple/i.test(navigator.vendor)) {
			resizeCallbacks.push(this);
		}
	}

	resize() {
		/*
		Fix pour Safari qui ne sait pas réévaluer la postion d'un élément
		déplacé par une animation css keyframes
		*/

		const pageContainer = document.querySelector(".page-container");
		pageContainer.classList.remove("animated-bg");
		setTimeout(() => {
			pageContainer.classList.add("animated-bg");
		}, 100);
	}
}